module.exports = __webpack_public_path__ + "static/media/26UNRWA26.86a5388e.jpg";